<template>
  <div>
    <v-layout class="mt-5">
      <h3 class="font-weight-regular">
        {{ school.nmescola }}
      </h3>
    </v-layout>
    <v-layout>
      <v-row no-gutters class="mt-5">
            <v-col lg="6">
              <!-- <Validate :v="$v.form.identificadorsegmentoestoqueescola"> -->
                <v-autocomplete
                  v-model="segmentoSelecionado"
                  :items="segmentoOptions"
                  outlined
                  label=""
                  :no-data-text="segmentoLoading ? 'Carregando dados, aguarde...' : form.segmentoSearch ? `Nenhuma opção encontrada com '${form.segmentoSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="form.segmentoSearch"
                  :loading="segmentoLoading"
                  loader-height="3"
                  placeholder="Primeiro, selecione o segmento do estoque"
                ></v-autocomplete>
              <!-- </Validate> -->
            </v-col>
        </v-row>
    </v-layout>
    <v-layout>
      <v-flex xs2 class="mr-3">
        <v-select
          v-model="buscarSelect"
          :items="buscaOptions"
          label="Tipo de busca"
          outlined
          menu-props="offsetY"
        ></v-select>
      </v-flex>
      <v-flex xs6>
        <v-autocomplete
          outlined
          :search-input.sync="searchBusca"
          :hide-no-data="!searchBusca && listaOptions.length == 0"
          :no-data-text="buscarLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${searchBusca}'`"
          :loading="buscarLoading"
          :items="listaOptions"
          hide-selected
          item-text="descricaoalimentosmar"
          item-value="identificadordepositoescola"
          label="Buscar por"
          placeholder="Digite um valor para buscar"
          prepend-inner-icon="search"
          return-object
          @keydown="handleBusca"
          :disabled="!segmentoSelecionado"
        >
          <template v-slot:item="{ item }">
            <div class="py-2" @click="selectBusca(item)">{{item.descricaoalimentosmar}}</div>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao || !segmentoSelecionado"
      :id="form.identificadordepositoescola"
      :novo="novoDepositoDaEscola"
      :editar="editarDepositoDaEscola"
      :excluir="excluirDepositoDaEscola"
      :cancelar="cancelarDepositoDaEscola"
      :submit="onSubmit"
    >
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaDepositoDaEscola">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <v-row no-gutters>
            <v-col  lg="6">
              <v-text-field  label="Código Depósito da Escola" v-model="form.identificadordepositoescola" outlined disabled background-color="#f2f2f2"></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.identificadorescolalocalexterno">
               <v-text-field slot-scope="{ props }"
                v-bind="props" v-model="form.nomeescola"
                label="Escola" outlined
                readonly tabindex="-1"  ></v-text-field>
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.identificadorsegmentoestoqueescola">
                <v-autocomplete
                slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadorsegmentoestoqueescola"
                  :items="segmentoOptions"
                  outlined
                  label="Segmento do Estoque*"
                  :no-data-text="segmentoLoading ? 'Carregando dados, aguarde...' : form.segmentoSearch ? `Nenhuma opção encontrada com '${form.segmentoSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="form.segmentoSearch"
                  readonly
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  :loading="segmentoLoading"
                  loader-height="3"
                ></v-autocomplete>
              </Validate>
              <!-- :disabled="isFormDisabled || acao === 'editar' " -->
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.identificadoralimento">
                <v-autocomplete
                slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadoralimento"
                  :items="alimentosOptions"
                  outlined
                  label="Identificador Alimento*"
                  :no-data-text="alimentosLoading ? 'Carregando dados, aguarde...' : form.alimentoSearch ? `Nenhuma opção encontrada com '${form.alimentoSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="form.alimentoSearch"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  :loading="alimentosLoading"
                  loader-height="3"
                  @focus="loadAlimentosOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>



          <v-row no-gutters>
            <v-col lg="6">
              <!-- <Validate :v="$v.form.identificadorescola"> -->
               <v-text-field
                 v-model="this.unidademedidaalimento"
                label="Unidade de medida" outlined
                readonly tabindex="-1"  ></v-text-field>
              <!-- </Validate> -->
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <v-text-field
                v-mask="['#.##', '##.##', '###.##', '####.##', '#####.##', '######.##', '#######.##', '########.##', '#########.##']"
                v-model="form.quantidadeestoque"
                label="Quantidade Estoque"
                disabled
                outlined
              />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.quantidadeseguranca">
                <v-text-field
                  v-mask="['#.##', '##.##', '###.##', '####.##', '#####.##', '######.##', '#######.##', '########.##', '#########.##']"
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.quantidadeseguranca"
                  label="Estoque mínimo"
                  outlined
                  :disabled="acao == '' || acao == 'excluir'"
                  maxlength="10"
                />
              </Validate>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.localarmazenamento">
                <v-text-field   slot-scope="{ props }" v-bind="props" v-model="form.localarmazenamento" label="Local Armazenamento" outlined  :disabled="acao == '' || acao == 'excluir'"  maxlength="30" ></v-text-field>
              </Validate>
            </v-col>

          </v-row>

        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { required, integer, maxLength, decimal } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const EscolaRepository = RepositoryFactory.get("escola");
const DepositoDaEscolaRepository = RepositoryFactory.get("depositoDaEscolaRepository");
const DepositoGeralSMAERepository = RepositoryFactory.get("depositoGeralSMAERepository");
const SegmentoEstoqueRepository = RepositoryFactory.get("segmentoEstoque");

export default {
  name: 'DepositoDaEscola',
  data() {
    return {
      items: [],
      acao: '',
      form: this.setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaoalimentosmar',
      buscaOptions: [
        { value: 'identificadoralimento', text: 'Identificador Alimento' },
        { value: 'descricaoalimentosmar', text: 'Descrição Alimento' },
      ],
      cardapioOptions: [],
      cardapiosLoading: false,
      escolaOptions: [],
      escolasLoading: false,
      alimentosLoading: false,
      segmentoLoading: false,
      alimentosOptions: [],
      segmentoOptions: [],
      formUltimo: {},
      textoBusca: '',
      searchBusca: '',
      listaOptions: [],
      buscarLoading: false,
      segmentoSelecionado: '',
    };
  },
  watch: {
    'form.alimentoSearch'(newVal, oldVal) {
      const novoValor = newVal ?? ''
      if(novoValor.length < 3) return
      clearTimeout(this._searchTimeId)
      this._searchTimeId = setTimeout(async () => {
                                                    await this.loadAlimentosOptions()
                                                  }, 1000
                                    )
    },
  },
  computed: {
    ...mapGetters(['school']),
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir'
    },
    unidademedidaalimento() {
      return (this.alimentosOptions.length > 0 && this.form.identificadoralimento) ?
              this.alimentosOptions.find( a => a.value === this.form.identificadoralimento).medida
              : ''
    },
  },
  validations: {
    form: {
      identificadoralimento: { required },
      identificadorescolalocalexterno: {required},
      quantidadeseguranca: { decimal, maxLength: maxLength(10)},
      localarmazenamento: { maxLength: maxLength(30)},
      identificadorsegmentoestoqueescola : {required, integer}
    }
  },
  async mounted() {
    this.loadSegmentoOptions();
    this.$Progress.finish();
  },
  methods: {
    setFormInicial() {
      return ({
        identificadordepositoescola: '',
        identificadorescolalocalexterno: (this.school) ? this.school.identificadorescolalocalexterno : '',
        nomeescola: (this.school) ? this.school.nmescola : '',
        escolaSearch: '',
        alimentoSearch: '',
        identificadoralimento: '',
        quantidadeestoque: 0,
        quantidadeseguranca: '',
        localarmazenamento: '',
        identificadorsegmentoestoqueescola: this.segmentoSelecionado,
      })

    },
    handleBusca() {
      //const novoValor = this.searchBusca ?? ''
       // if(novoValor.length < 1) return
      clearTimeout(this._searchTimeId)
      this.listaOptions = []
      this._searchTimeId = setTimeout(async () => {
                                                    await this.listarRegistros()
                                                  }, 1000
                                    )
    },
    async listarRegistros() {
      try {

        this.buscarLoading = true
        const { data } = await DepositoDaEscolaRepository.listarDepositoDaEscola({
         identificadorescolalocalexterno: this.school.identificadorescolalocalexterno,
         identificadorsegmentoestoqueescola: this.segmentoSelecionado,
        //  descricaoalimentosmar: this.searchBusca
        [this.buscarSelect]: this.searchBusca
        })
        this.listaOptions = data.results.map( a => {
          return {
            ...a,
            descricaoalimentosmar: `${a.identificadoralimento} - ${a.descricaoalimentosmar}, Segmento: ${a.descricaosegmentoestoqueescola}`
          }
        })
      } catch (error) {
        console.error(error)
      }
      finally {
        this.buscarLoading = false

      }
    },
    preencheCampoEscola(identificadorescolalocalexterno, nomeescola) {
      this.form.identificadorescolalocalexterno = identificadorescolalocalexterno
      this.form.nomeescola = nomeescola
    },
    preencheCampoSegmento(identificadorsegmentoestoqueescola, descricaosegmentoestoqueescola) {
      this.form.identificadorsegmentoestoqueescola = identificadorsegmentoestoqueescola
      this.form.descricaosegmentoestoqueescola = descricaosegmentoestoqueescola

      this.segmentoOptions.push({
        text: descricaosegmentoestoqueescola,
        value: identificadorsegmentoestoqueescola
      })
    },
    preencheCampoAlimento(identificadoralimento, descricaoalimentosmar) {
      this.form.identificadoralimento = identificadoralimento
      this.alimentoSearch = descricaoalimentosmar

      this.alimentosOptions.push({
        text: descricaoalimentosmar,
        value: identificadoralimento
      })
    },

    selectBusca(item) {

      this.form = item
      this.form.identificadordepositoescola = item.identificadordepositoescola
      this.form.identificadorescolalocalexterno = item.identificadorescolalocalexterno
      this.form.nomeescola = this.school.nmescola

      this.form.identificadoralimento = item.identificadoralimento
      this.alimentoSearch = item.descricaoalimentosmar
      this.segmentoSearch = item.descricaosegmentoestoqueescola
      this.alimentosOptions = []

      this.alimentosOptions.push({
        text: item.descricaoalimentosmar.split(',')[0],
        value: this.form.identificadoralimento,
        medida: item.unidademedidaalimento
      })
      this.segmentoOptions = []
      this.segmentoOptions.push({
        text: item.descricaosegmentoestoqueescola,
        value: item.identificadorsegmentoestoqueescola
      })


      this.listaOptions = []
      this.searchBusca = ''
      this.textoBusca = ''

    },
    tabelaDepositoDaEscola() {
      this.$root.$router.push({
        name: 'tabelas',
         query: {
          identificadorescolalocalexterno: this.school.identificadorescolalocalexterno
        },
        params: {
          titulo: 'Estoque da Escola / Listar',
          rota_api: `merenda/deposito-da-escola/tabela/${this.school.identificadorescolalocalexterno}`,
          headers: [{ text: 'Identificador Depósito Escola', value: 'identificadordepositoescola', sortable: false },
                    { text: 'Código Alimento SMAR', value: 'codigoalimentosmar', sortable: false },
                    { text: 'Identificador Alimento', value: 'identificadoralimento', sortable: false },
                    { text: 'Descrição Alimento', value: 'descricaoalimentosmar', sortable: false },
                    { text: 'Local Armazenamento', value: 'localarmazenamento', sortable: false },
                    { text: 'Segmento', value: 'descricaosegmentoestoqueescola', sortable: false }
                  ],
        },
      });
    },
    novoDepositoDaEscola() {
      this.acao = 'novo';
      this.form = this.setFormInicial();
      this.$v.$reset();
    },
    editarDepositoDaEscola() {
      this.acao = 'editar';
    },
    cancelarDepositoDaEscola() {
      if (this.acao == 'novo') {
        this.form = this.setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirDepositoDaEscola() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este alimento neste depósito?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await DepositoDaEscolaRepository.deletarDepositoDaEscola(this.form.identificadordepositoescola);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = this.setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        const { data } = await DepositoDaEscolaRepository[this.acao === 'novo' ? 'criarDepositoDaEscola' : 'editarDepositoDaEscola'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };

        const {identificadorescolalocalexterno, identificadoralimento, descricaoalimentosmar, identificadorsegmentoestoqueescola, descricaosegmentoestoqueescola } = data.results
        this.preencheCampoEscola(identificadorescolalocalexterno, this.school.nmescola)
        this.preencheCampoAlimento(identificadoralimento, descricaoalimentosmar)
        this.preencheCampoSegmento(identificadorsegmentoestoqueescola, descricaosegmentoestoqueescola)

      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }

      this.$v.$reset();
    },
    encontrado(dados) {
      this.form = this.setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
      this.$refs.buscaSimpleApi.lista = [];
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },

    async loadEscolaOptions() {
      if (this.escolaOptions.length) {
        return
      }

      this.escolasLoading = true
      const { data } = await EscolaRepository.recebeMerenda();
      for (const key of data.results) {
        this.escolaOptions.push({ value: `${key.cdtipesc}-${key.cdescola}`, text: key.nmescola })
      }
      this.escolasLoading = false
    },
    async loadAlimentosOptions() {
      this.alimentosLoading = true
      const { data } = (this.form.alimentoSearch) ? await DepositoGeralSMAERepository.buscarDepositoDaEscola({
                                                                                                              descricaoalimentosmar: this.form.alimentoSearch ?? ''
                                                                                                            })
                                                  : await DepositoGeralSMAERepository.buscarDepositoDaEscola()
      for (const key of data.results) {
        this.alimentosOptions.push({ value: key.identificadoralimento, text: `${key.codigoalimentosmar} - ${key.descricaoalimentosmar}`, medida: key.unidademedidaalimento })
      }
      this.alimentosLoading = false
    },
    async loadSegmentoOptions() {
      this.segmentoLoading = true
      this.segmentoOptions = []
      const { data } = (this.form.segmentoSearch) ? await SegmentoEstoqueRepository.buscarSegmentosEstoque({
                                                                                                              descricaosegmentoestoqueescola: this.form.segmentoSearch ?? ''
                                                                                                            })
                                                  : await SegmentoEstoqueRepository.buscarSegmentosEstoque()
      for (const key of data.results) {
        this.segmentoOptions.push({ value: key.identificadorsegmentoestoqueescola, text: key.descricaosegmentoestoqueescola })
      }
      this.segmentoLoading = false
    }

  },
};
</script>

<style>

</style>
